export default "__VITE_ASSET__rN_1li4k2aIbHGs0zKW8QQ__ 480w, __VITE_ASSET__m8R6TgWxwop2r_xOIPNRtg__ 768w, __VITE_ASSET__6MQCagmCrZzS5dHPKhXWKQ__ 1200w";